import { Children, Fragment, type ReactNode } from 'react';
import type { ListViewState } from '@erp/shared';
/** Retains each list's existing cell renderers while applying the common column state. */
export function OrderedListCells({
  columns,
  ids,
  children,
}: {
  columns: ListViewState['columns'];
  ids: readonly string[];
  children: ReactNode;
}): JSX.Element {
  const cells = Children.toArray(children);
  return (
    <>
      {columns
        .filter((c) => c.visible)
        .map((column) => (
          <Fragment key={column.id}>{cells[ids.indexOf(column.id)]}</Fragment>
        ))}
    </>
  );
}
